import { pathOr } from 'ramda'
import { timer } from 'rxjs'
import { map, mergeMap, pluck, retryWhen, scan } from 'rxjs/operators'

export const checkStatus =
  (maxStatus = 300) =>
  (data) => {
    if (data.status >= 200 && data.status < maxStatus) {
      return data
    }
    throw data
  }

const responseDataPath = pathOr(null, ['data'])

export const pluckData = () => responseDataPath

export const rxCheckStatus = (...args) => map(checkStatus(...args))

export const rxRetryWithBackoff = (
  retries = 3,
  backoff = (count) => Math.pow(2, count) * 1000,
  excludedStatusCodes = [403, 404]
) =>
  retryWhen((errors) => {
    return errors.pipe(
      scan((count, error) => {
        if (
          count >= retries ||
          excludedStatusCodes.find((statusCode) => statusCode === error.status)
        ) {
          throw error
        }
        return count + 1
      }, 0),
      mergeMap((count) => timer(backoff(count)))
    )
  })

export const rxPluckData = () => pluck('data')
